module.exports = __webpack_public_path__ + "img/email.343e997f.svg";